import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { getOfferItems, getTrustItems, getNavItems } from "./navData";
import SocialIcons from "./SocialIcons";
import LanguageSelector from "./LanguageSelector";
import SiteSearch from "./SiteSearch";

interface MobileMenuProps {
  onClose: () => void;
}

const MobileMenu = ({ onClose }: MobileMenuProps) => {
  const { lang, t } = useLanguage();
  const [offerOpen, setOfferOpen] = useState(false);
  const [trustOpen, setTrustOpen] = useState(false);
  

  const offerItems = getOfferItems(t, lang);
  const trustItems = getTrustItems(t, lang);
  const navItems = getNavItems(t, lang);

  return (
    <div className="lg:hidden border-t border-border bg-background animate-fade-in max-h-[calc(100vh-56px)] overflow-y-auto">
      <nav className="container py-4 flex flex-col gap-3">
        {navItems.map((item) =>
          item.dropdown ? (
            <div key={item.href}>
              <button
                onClick={() => {
                  if (item.dropdown === "offer") setOfferOpen(!offerOpen);
                  else if (item.dropdown === "trust") setTrustOpen(!trustOpen);
                }}
                className="flex items-center justify-between w-full text-base font-medium text-muted-foreground hover:text-foreground py-3"
              >
                {item.label}
                <ChevronDown className={`w-4 h-4 transition-transform ${(item.dropdown === "offer" ? offerOpen : trustOpen) ? "rotate-180" : ""}`} />
              </button>
              {item.dropdown === "trust" && trustOpen && (
                <div className="pl-4 flex flex-col gap-0">
                  <span className="text-xs uppercase tracking-wider text-muted-foreground/60 font-semibold pt-1 pb-1">Reference</span>
                  {trustItems.reference.map((sub) => (
                    <a key={sub.href} href={sub.href} onClick={() => { onClose(); setTrustOpen(false); }} className="text-sm text-muted-foreground hover:text-foreground py-2 min-h-6 flex items-center gap-2">
                      <sub.icon className="w-4 h-4 text-primary/70" />{sub.label}
                    </a>
                  ))}
                  <div className="border-t border-border/50 my-1.5" />
                  <span className="text-xs uppercase tracking-wider text-muted-foreground/60 font-semibold pb-1">Testimonials</span>
                  {trustItems.testimonials.map((sub) => (
                    <a key={sub.href} href={sub.href} onClick={() => { onClose(); setTrustOpen(false); }} className="text-sm text-muted-foreground hover:text-foreground py-2 min-h-6 flex items-center gap-2">
                      <sub.icon className="w-4 h-4 text-primary/70" />{sub.label}
                    </a>
                  ))}
                  <div className="border-t border-border/50 my-1.5" />
                  <span className="text-xs uppercase tracking-wider text-muted-foreground/60 font-semibold pb-1">Partners</span>
                  {trustItems.partners.map((sub) => (
                    <a key={sub.href} href={sub.href} onClick={() => { onClose(); setTrustOpen(false); }} className="text-sm text-muted-foreground hover:text-foreground py-2 min-h-6 flex items-center gap-2">
                      <sub.icon className="w-4 h-4 text-primary/70" />{sub.label}
                    </a>
                  ))}
                </div>
              )}
              {item.dropdown === "offer" && offerOpen && (
                <div className="pl-4 flex flex-col gap-1">
                  {offerItems.map((sub) => (
                    <div key={sub.href}>
                      <a href={sub.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-sm text-muted-foreground hover:text-foreground py-2 min-h-6 flex items-center gap-2">
                        <sub.icon className="w-4 h-4 text-primary/70" />{sub.label}
                      </a>
                      {sub.subItems && sub.subItems.length > 0 && (
                        <div className="pl-6 flex flex-col gap-0.5">
                          <a href={sub.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-xs font-semibold text-foreground hover:text-primary py-2 min-h-6 pl-2 flex items-center">
                            {lang === "en" ? "All Products" : "Vsi produkti"} →
                          </a>
                          <div className="border-t border-border/50 my-0.5" />
                          {sub.subItems.map((cat: any, ci: number) =>
                            cat.isCategory ? (
                              <div key={ci}>
                                {cat.href ? (
                                  <a href={cat.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-xs uppercase tracking-wider text-primary font-semibold py-2 min-h-6 flex items-center hover:underline">{cat.label}</a>
                                ) : (
                                  <span className="text-xs uppercase tracking-wider text-primary font-semibold pt-1 pb-0.5 block">{cat.label}</span>
                                )}
                                {cat.subItems?.map((child: any) =>
                                  child.isCategory ? (
                                    <div key={child.label}>
                                      {child.href ? (
                                        <a href={child.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-xs text-muted-foreground/80 hover:text-foreground font-normal py-2 min-h-6 pl-2 border-l border-border/50 flex items-center">{child.label}</a>
                                      ) : (
                                        <span className="text-xs text-muted-foreground/80 font-normal pt-0.5 pb-0 pl-2 border-l border-border/50 block">{child.label}</span>
                                      )}
                                      {child.subItems?.map((grandchild: any) => (
                                        <a key={grandchild.href} href={grandchild.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-xs text-muted-foreground/80 hover:text-foreground py-2 min-h-6 pl-4 border-l border-border/50 flex items-center">
                                          {grandchild.label}
                                        </a>
                                      ))}
                                    </div>
                                  ) : (
                                    <a key={child.href} href={child.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-xs text-muted-foreground/80 hover:text-foreground py-2 min-h-6 pl-2 border-l border-border/50 flex items-center">
                                      {child.label}
                                    </a>
                                  )
                                )}
                              </div>
                            ) : (
                              <a key={cat.href} href={cat.href} onClick={() => { onClose(); setOfferOpen(false); }} className="text-xs text-muted-foreground/80 hover:text-foreground py-2 min-h-6 pl-2 border-l border-border/50 flex items-center">
                                {cat.label}
                              </a>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
               )}
            </div>
          ) : (
            <a key={item.href} href={item.href} onClick={onClose} className="text-base font-medium text-muted-foreground hover:text-foreground py-3">
              {item.label}
            </a>
          )
        )}
        <div className="flex items-center gap-3 pt-2">
          <SiteSearch />
          <LanguageSelector />
        </div>
        <div className="flex items-center gap-4 pt-4 mt-2 border-t border-border/30">
          <SocialIcons iconSize="w-5 h-5" className="gap-4" />
        </div>
      </nav>
    </div>
  );
};

export default MobileMenu;
